import { Group, Namespace } from "./model";

// Default translations: US English

export default {
  [Namespace.DEFAULT]: {
    [Group.DEFAULT]: {
      accountHolder: "Account holder",
      accountId: "Account ID",
      active: "Active",
      addNewFile: "Add new file",
      apply: "Apply",
      auditLog: "Audit log",
      auditStatus: "Audit status",
      awaitingData: "Waiting for data",
      awaitingReview: "Awaiting review",
      back: "Back",
      beingReviewed: "Being reviewed",
      blank: "--",
      bulkAction: "Bulk action",
      cancel: "Cancel",
      saveEdits: "Save edits",
      category: "Category",
      claimedBy: "Claimed by",
      clearSelection: "Clear selection",
      close: "Close",
      collapse: "Collapse",
      collectedAt: "Collected at",
      collectedFrom: "Collected from",
      complete: "Complete",
      configure: "Configure",
      createdAt: "Created at",
      current: "Current",
      custom: "Custom",
      dataIssue: "Data issue",
      dataSettings: "Data settings",
      dataSource: "Data source",
      dataSubmission: "Data submission",
      dataSubmitter: "Data Submitter",
      date: "Date",
      dateFormat: "dd MMM yyyy",
      dateTimeFormat: "dd MMM yyyy 'at' hh:mmaaa",
      delete: "Delete",
      description: "Description",
      details: "Details",
      draft: "Draft",
      download: "Download",
      downloadFile: "Download {{name}}",
      downloadSuccessful: "Download successful",
      emissionDetails: "Emission Details",
      emissionsReady: "Emissions ready",
      emptyAlert: "Nothing to display",
      endDate: "End date",
      estimationMethod: "Estimation method",
      exit: "Exit",
      expand: "Expand",
      export: "Export",
      exportExcel: "Export Excel sheet (.xls)",
      exportToExcel: "Export to Excel",
      fileName: "File name",
      fileSize: "File size",
      files: "File(s)",
      filesUploaded: "Files uploaded",
      filterBy: "Filter by",
      group: "Group",
      groupBy: "Group by",
      id: "ID",
      info: "Info",
      inputData: "Input data",
      instructions: "Instructions",
      kgCO2e: "kgCO₂e",
      lastCollection: "Last collection",
      nextCollection: "Next collection",
      lastAttempt: "Last attempt",
      lastUpdate: "Last update",
      lastSubmitted: "Last submitted",
      lastUpload: "Last upload",
      latestStatus: "Latest status",
      locationBased: "Location Based",
      marketBased: "Market Based",
      meterId: "Meter ID",
      methodology: "Methodology",
      more: "more",
      moreFilters: "More filters",
      name: "Name",
      never: "Never",
      new: "New",
      no: "No",
      none: "None",
      noResults: 'No results found for "{{searchTerm}}"',
      notApplicable: "N/A",
      notSet: "Not set",
      notUsed: "Not used",
      notes: "Notes",
      off: "Off",
      on: "On",
      optional: "(optional)",
      organization: "Organization",
      paginatorRowsPerPage: "Rows per page",
      paginatorRange: "{{start}} – {{end}} of {{total}}",
      percent: "{{count}}%",
      permissionDenied: "You do not have permission to perform this action.",
      pleaseSelect: "Please select",
      previewInNewTab: "Preview in new tab",
      processing: "Processing",
      providerStatus: "Provider status",
      quantity: "Quantity",
      reload: "Reload",
      replace: "Replace",
      replaced: "Replaced: {{name}}",
      replacedNew: "NEW: {{name}}",
      replacing: "Replacing",
      replacement: "Replacement",
      reportingEntity: "Reporting entity",
      reportingYear: "Reporting year",
      reportingYearTooltip:
        "You must select an Organization before filtering by Reporting Year",
      reset: "Reset",
      review: "Review",
      save: "Save",
      scope: "Scope",
      scope3Category: "Scope 3 Category",
      searchPlaceholder: "Search something",
      selectAll: "Select all ({{count}})",
      selectDateRange: "Select date range",
      selectReportingPeriod: "Select reporting period",
      sendEmailReminder: "Send Email Reminder",
      showResults: "Show results",
      sourceFiles: "Source files ({{count}})",
      sourceData: "Source data",
      startDate: "Start date",
      status: "Status",
      statusDetail: "Status detail",
      submission: "Submission",
      submissionCadence: "Submission cadence",
      submissionGroup: "Submission group",
      submissionSlot: "Submission slot",
      submit: "Submit",
      next: "Next",
      submitData: "Submit data",
      submittedAt: "Submitted at",
      submittedBy: "Submitted by",
      submittedItems: "Submitted items",
      submittedOn: "Submitted on",
      savedby: "Saved by",
      savedItems: "Saved items",
      lastSaved: "Last saved",
      tonnesCO2e: "tCO₂e",
      totalEmissions: "Total emissions",
      threshold: "Threshold",
      timeSlot: "Time slot",
      timePeriod: "Time period",
      total: "Total",
      totalOfResults: "Total of {{count}} results",
      transactionId: "Transaction ID",
      unknown: "Unknown",
      unused: "Not used",
      update: "Update",
      updateFiles: "Update files",
      upload: "Upload",
      uploadedBy: "Uploaded by",
      uploadedOn: "Uploaded on",
      uploadReplacementFile: "Upload replacement file",
      user: "User",
      validity: "Validity",
      validFrom: "Valid from",
      validTo: "Valid to",
      version: "Version",
      view: "View",
      viewData: "View data",
      viewDetails: "View details",
      viewMore: "View more",
      varianceCheckOff: "Variance check off",
      yearOnYear: "Year on year",
      yes: "Yes",
      lastUpdated: "Last updated {{refreshedTime}}",
      refreshedOn: "Refreshed on ",

      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],

      daysShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],

      action_one: "Action",
      action_other: "Actions",
      activity_one: "Activity",
      activity_other: "Activities",
      activityTag_one: "Activity tag",
      activityTag_other: "Activity tags",
      cadence_one: "Cadence",
      cadence_other: "Cadences",
      country_one: "Country",
      country_other: "Countries",
      dataManager_one: "Data manager",
      dataManager_other: "Data managers",
      dataManagerInSubmissionGroup_one: "data manager in {{name}}",
      dataManagerInSubmissionGroup_other: "data managers in {{name}}",
      dataSubmitter_one: "Data submitter",
      dataSubmitter_other: "Data submitters",
      dataSubmitterInSubmissionGroup_one: "data submitter in {{name}}",
      dataSubmitterInSubmissionGroup_other: "data submitters in {{name}}",
      emission_one: "Emission",
      emission_other: "Emissions",
      entity_one: "Entity",
      entity_other: "Entities",
      entityInSubmissionGroup_one: "entity in {{name}}",
      entityInSubmissionGroup_other: "entities in {{name}}",
      file_one: "{{count}} file",
      file_other: "{{count}} files",
      integration_one: "Integration",
      integration_other: "Integrations",
      location_one: "Location",
      location_other: "Locations",
      period_one: "Period",
      period_other: "Periods",
      selectDate_one: "Select date",
      selectDate_other: "Select dates",
      source_one: "Source",
      source_other: "Sources",
      tag_one: "Tag",
      tag_other: "Tags",
      utilityProvider_one: "Utility provider",
      utilityProvider_other: "Utility providers",
    },

    [Group.TABS]: {
      analytics: "Analytics",
      atlas: "Atlas",
      dataSubmission: "Data submission",
      dataSubmissionLegacy: "Data submission (legacy)",
      documents: "Documents",
      emissions: "Emissions",
      home: "Home",
      integrationHealth: "Integration health",
      methodologies: "Methodologies",
      projectManagement: "Project management",
      reports: "Reports",
      collectionStatus: "Collection status",
      transactions: "Transactions",
    },

    [Group.MODAL]: {
      exitCancel: "No, cancel",
      exitConfirm: "Yes, leave",
      exitContent:
        "Are you sure you want to leave this submission and not save progress? By doing so you will be required to start this submission from the beginning.",
      exitContentUnresolvedVariances:
        "Some variances are still unresolved. Your comments have been saved, so you can come back and finish later.",
      exitTitle: "Leave data submission",
      downloadAs: "Download as {{fileType}}",
      document: "Document",
      documentPreview: "{{fileName}} preview",
    },

    [Group.TEMPLATES]: {
      columnDescription: "Column description",
      columnName: "Column name",
      example: "Example",
      methodologyPreviewHeading:
        "The following is a description of each column you’re required to provide data for in the template. You can download the template by clicking the button below.",
      methodologyPreviewSubHeading:
        "Below is an example row of valid data you can submit.",
    },

    [Group.SCOPE_2]: {
      electricityCalculationApproach: "Electricity Calculation Approach",
      electricityCalculationContent: `
      <heading>What are the electricity calculation approaches?</heading>
      <content>
      The Greenhouse Gas Protocol Scope 2 guidance specifies two possible approaches to calculating emissions associated with electricity consumption: location-based and market-based. Because electricity consumption occurs at various points up and down the corporate value chain, the Minimum platform enables the distinction between the two approaches to be made beyond one company's Scope 2 boundary.
      </content>
      <heading>What is location-based calculation approach?</heading>
      <content>
      Location-based takes the average emissions intensity of the electricity supplied via the grid. Physically, there is no way of distinguishing the source of electricity consumed once it has passed through the grid and therefore the average is used for the location-based approach.
      </content>
      <heading>What is market-based calculation approach?</heading>
      <content>
      In the market-based case, the contractual supply is taken into account and an organisation can choose to procure renewable electricity from a supplier who has to demonstrate that this electricity is backed by Renewable Energy Certificates (RECs) or Renewable Energy Guarantee of Origin (REGO) certificates. The reasoning is that users get rewarded for making a specific choice of using renewable electricity, which drives demand for more renewable capacity.
      </content>`,
    },

    [Group.SCOPE_3]: {
      title: "Scope 3 Category",
      scope3CategoryNames: [
        null,
        "Purchased Goods and Services",
        "Capital Goods",
        "Fuel- and Energy-Related Activities",
        "Upstream Transportation and Distribution",
        "Waste Generated in Operations",
        "Business Travel",
        "Employee Commuting",
        "Upstream Leased Assets",
        "Downstream Transportation and Distribution",
        "Processing of Sold Products",
        "Use of Sold Products",
        "End-of-Life Treatment of Sold Products",
        "Downstream Leased Assets",
        "Franchises",
        "Investments",
      ],
    },

    [Group.SUBMIT_MODAL]: {
      title: "Submit data",
      content: "Please confirm you wish to submit this data.",
      error: "Failed to submit data",
      success: "Submission completed",

      confirmTaskResetTitle: "Confirm task reset",
      confirmTaskResetContent:
        "Resetting a task will return it to the cleaning step",
      confirmReset: "Confirm reset",
      taskResetInProgressTitle: "Task reset in progress",
      taskResetInProgressContent:
        "This task is being reset, you will receive a slack notification once complete",
      returnToList: "Return to list",
      continueWithTask: "Continue with task",
    },

    [Group.VARIANCE_CHECKS]: {
      pageName: "Preview file",
      currentValue: "Current value",
      dimension: "Dimension",
      metadata: "Metadata",
      previousPeriod: "Previous period",
      previousYear: "Previous year",
      sourceFiles: "Source files",
      comments: "Comments",
      resolutionStatus: "resolution status",
      status: "Status",
      dataIssue: "Data issue",
      commentAdded: "Comment added",
      resolved: "Resolved",
      varianceTooltip:
        "The current value of {{value}} {{unit}} is {{variance}}% {{direction}} than the previous value {{previousValue}} {{unit}}",
      varianceHigher: "higher",
      varianceLower: "lower",
    },
  },

  [Namespace.ERROR]: {
    [Group.DEFAULT]: {
      appUpdatedTitle: "Application Updated",
      appUpdatedText:
        "Our application has been updated. To continue using Minimum please reload this page in your browser.",
      cannotLoadExplo: "Could not load Explo",
      cannotLoadDashboard:
        "We couldn't load this dashboard. Please try again later.",
      cannotLoadDashboards: "We couldn't load your dashboards.",
      contactSupport: "Contact support",
      fileDownloadFailed: "File download failed: No data returned",
      fileDownloadFailedError: "File download failed: {error}",
      fileUploadFailure: "Failed to upload file, please try again",
      loadingErrorTitle: "Error while loading",
      loadingErrorText:
        "Your data could not be loaded. Please try again, or contact support.",
      pageLoadErrorTitle: "Could not load page",
      pageLoadErrorText:
        "Something went wrong when trying to load this page, please reload your browser and try again.",
      retry: "Try again",
      genericError: "Operation unsuccessful",
      genericErrorText:
        "An error occurred while processing your request. Please try again later.",
      apiErrorText: "An API error occurred: {{action}} (status: {{status}})",
      errorOpeningTask: "Error opening task (status: {{status}})",
      pageNotFoundTitle: "Page not found 😕",
      pageNotFoundBody:
        "If you were expecting something else, <a>contact our support team</a> for help.",
      unableToValidate: " Unable to validate this file – ",
      downloadErrorLog: "download error log",
      forDetails: " for details.",
      referenceDocumentUploadFailed: `<titleSmall>Duplicate reference detected</titleSmall>
      <bodyMedium>Another file for ‘{{referenceDataType}}’ already exists within your selected date range <u>(see existing reference)</u></bodyMedium>
      <bodyMedium>To proceed, you’ll need to correct the conflicting dates either for the existing reference file or this submission. </bodyMedium>`,
    },
  },

  [Namespace.AUTHENTICATION]: {
    [Group.DEFAULT]: {
      accountNotFound:
        "We couldn't find a Minimum account matching that email address.",
      backToLogin: "Back to Login",
      defaultAuthError: "You were not able to login. Please try again.",
      emailSupport:
        "Please email <strong>{{email}}</strong> if you are facing any issues.",
      logout: "Log out",
      sessionTimeoutTitle: "Session timeout",
      sessionTimeoutMessage: `<bodyMedium> You've been inactive for a while. If you do nothing, we'll automatically sign you out shortly.</bodyMedium>
      <bodyMedium>Otherwise, you can choose to continue your session or log out immediately.</bodyMedium>`,
      logOutNow: "Log out now",
      continueSession: "Continue session",
    },

    [Group.LOGIN]: {
      pageName: "Login",
      redirect: "Redirecting to Minimum's Secure Login Portal.",
    },

    [Group.SUPPLIER_INVITATION]: {
      checkEmail: "Please check your email for further instructions.",
      emailAddress: "Email Address",
      enterEmail: "Enter your email address below to receive a login link",
      error: "Something went wrong. Please try again.",
      pageName: "Supplier Invitation",
      supplierLogin: "Supplier Login",
    },
  },

  [Namespace.HOME]: {
    [Group.DEFAULT]: {
      contactAnExpertButton: "Speak to an expert",
      contactAnExpertHeader: "Contact an expert",
      contactAnExpertSubheader:
        "Arrange a consultation with our experts for support on your carbon accounting and management journey.",
      dataSubmissionAndManagement: "Data submission and management",
      footprintAndReportingHeader: "Footprint & Reporting",
      pageName: "Home",
      speakToUsButton: "Speak to us",
      updateFeedHeader: "Update feed",
      noAccessTitle: "Welcome - we're preparing your access",
      noAccessText:
        "You've successfully signed in, but your access permissions are currently being configured. Please try again later.",
      welcomeTitleName: "Welcome, {{name}}",
      welcomeTitle: "Welcome to Minimum",
      welcomeText: ` Manage your organization’s Carbon Accounting requirements with ease
      through Minimum’s Emissions Data Platform. Access and submit data, track
      progress, analyze your footprint, and generate reports seamlessly.
      Explore the features below to learn how our platform can help enable a
      more sustainable future for your organization.`,
    },

    [Group.CONSOLIDATION]: {
      consolidationApproach: "Consolidation Approach",
      dateUsedForConsolidation: "Date Used for Consolidation",
      reportingEntity: "Reporting Entity",
      electricityDefaultApproach: "Electricity Calculation default approach",
    },

    [Group.DATA_COLLECTION]: {
      overallManaulDataSubmission: "Overall manual data submission",
      seeProgressDetails: "See progress details",
    },

    [Group.SUMMARY]: {
      footprintHeader: "Footprint summary for reporting year {{reportingYear}}",
      scope1Emissions: "Scope 1 emissions",
      scope2Emissions: "Scope 2 emissions",
      scope3Emissions: "Scope 3 emissions",
    },

    [Group.CARDS]: {
      analyticsCardLabel: "Analytics",
      analyticsCardHeader: "Inspect footprint insights",
      analyticsCardSubheader:
        "Uncover insights and pinpoint hotspots in your carbon footprint through diverse data breakdowns.",
      analyticsCardButton: "Go to Analytics",

      emissionCardLabel: "Emissions",
      emissionCardHeader: "View granular carbon data",
      emissionCardSubheader:
        "Access detailed carbon footprint data, and export it for analysis.",
      emissionCardButton: "Go to Emissions",

      reportsCardLabel: "Reports",
      reportsCardHeader: "Request a report",
      reportsCardSubheader:
        "Stay ahead of mandatory and voluntary reporting requirements, with industry-standard reporting options.",
      reportsCardButton: "Go to Reports",
    },
  },

  [Namespace.ATLAS]: {
    [Group.DEFAULT]: {
      associatedUsers: "Associated Users",
      continueToDataSubmission: "Continue to data submission",
      header: "Atlas View",
      industry: "Industry",
      location: "Location",
      noPermission: "You do not have permission to view data for {{name}}.",
    },
  },

  [Namespace.DATA_COLLECTION]: {
    [Group.DEFAULT]: {
      dataSubmission: "Data submission",
      close: "Close slot and mark as no data",
      confirmationText: "Please confirm you wish to save this data",
      dataSubmittedSuccess:
        "Your data has been submitted successfully. If no issues are detected, it’ll be processed to calculate your emissions. However, if issues are detected, you’ll be notified by email.",
      goToDataSubmission: "Go to Data Submissions",
      goToActionsRequired: "Go to Actions Required",
      reopen: "Request to re-open",
      saveDraft: "Save as draft",
      saveSuccess: "Your submission has been saved",
      saveData: "Save data",
      savedAsDraft: "Saved as draft",
      draftSaved: "Draft saved",
    },

    [Group.TABS]: {
      dataIssue: "Data issue ({{count}})",
      draftSubmissions: "Draft submissions ({{count}})",
      waitingForData: "Waiting for data ({{count}})",
      allSubmissions: "All submissions ({{count}})",
      dataIssueTooltip: "View submissions with data issues",
      dataIssueEmptyTooltip: "You have no data issues to review",
      draftSubmissionsTooltip: "View submissions with pending data to submit",
      draftSubmissionsEmptyTooltip: "You have no drafts to review",
      waitingForDataTooltip:
        "View submissions that are waiting for data to be submitted",
      allSubmissionsTooltip: "View previous, current and upcoming submissions",
    },

    [Group.SUBMISSION_GROUP]: {
      seeAutomatedCollections: "See automated collections",
      header: "Submit data",
      noActions: "There are no Actions for you to view at this time.",
      needsActionTab: "Needs action",
      noDataSubmissions:
        "There are no Data Submissions for you to view at this time.",
      pageName: "Submission Group",
      structureSubTitle:
        "This is how {{name}} structures its data submissions.",
      submissionSlotsTab: "Submission slots",
      subTitle:
        "Upload relevant files or submit surveys for this group’s submissions.",
      settingsTab: "Settings",
      reportingYearHasIntegrations:
        "At least one Entity is configured for integration",
      entityIntegrationHeader_one:
        "Manual submission not required for certain activities",
      entityIntegrationHeader_other:
        "Manual submission not required for certain entities",
      entityIntegrationDescription_one:
        "Data for {{activities}} is being collected automatically for {{entity}}. You do not need to manually submit data for those activities.",
      entityIntegrationDescription_other:
        "Some entities have data that is being collected automatically, so you do not need to manually submit anything for them.",
      entityIntegrationLink: "See list of automated collections",
      integrationModalTitle: "Automated collections",
      integrationModalTitleWithYear: "Automated collections for {{year}}",
      integrationModalMoreRows: "Showing {{count}} of {{total}} rows",
      integrationModalDownload: "Download full list",
      integrationModalFilename: "Automatic collections for {{date}}.csv",
    },

    [Group.SUBMISSION_GROUP_UPLOAD]: {
      exitConfirmation:
        "Are you sure you want to leave this submission? By doing so you will be required to start this submission from the beginning.",
      info: "You can upload multiple files here as an alternative method of providing data for this submission",
      permissionsTooltip:
        "Your user account does not have the necessary permissions to upload or modify data for this submission.",
    },

    [Group.SUBMISSION_SLOT_DETAILS]: {
      permissionsTooltip:
        "Your user account does not have the necessary permissions to upload or modify data for this submission.",
      uploadDataOneFile: "Upload data (one file only)",
      uploadData: "Upload data",
      uploadedFile: "Uploaded file",
      uploadedFiles: "Uploaded files",
      noActionRequired: "No action required",
      activityNotApplicable:
        "This activity has been marked as not applicable for this submission. If this is incorrect, please reach out to",
      submissionError:
        "An error has occurred with your submission. Please try again or contact Minimum support.",
      stillExperiencingIssues: "If you are still experiencing issues, please",
      contactSupport: "contact support.",
      uploadedData: "Uploaded data",
      unableToValidate: " Unable to validate this file – ",
      downloadErrorLog: "download error log",
      forDetails: " for details.",
      incorrectlyFormattedFile: "Incorrectly formatted file",
      incorrectlyFormattedFileMessage:
        "Your file was not submitted. Delete the original and then re-upload your correctly formatted file.",
      isCalculatingWithDraft:
        "You have draft data saved but you cannot submit it right now as we’re currently calculating emissions from data you’ve already submitted. If you need to modify or submit more data immediately, you can request to re-open the slot.",
      isCalculatingWithoutDraft:
        "You cannot submit data right now as calculations are currently being performed on data that’s been submitted. If you urgently need to modify what you’ve submitted, contact support.",
      calculatingEmissions: "Calculation in progress",
      draftWithUnsubmittedDataMessage:
        "This slot contains draft content that you’ve not finished submitting. You should press the “Submit” button when you’re ready for the data to be processed.",
      draftWithUnsubmittedFilesMessage:
        "This slot contains saved files that you’ve not finished submitting. You should press the “Submit” button when you’re ready for the files to be processed.",
      draftHintTitle: "This submission is still a draft",
      draftHintDataMessage:
        "Data you’ve saved hasn’t been submitted yet. Click <strong>Submit</strong> to send this data for processing.",
      draftHintFilesMessage:
        "Files you’ve uploaded haven’t been submitted yet. Click <strong>Submit</strong> to send this data for processing.",
      alertProcessing: `<titleSmall>Submitted file being processed</titleSmall>
         <bodyLarge>We’re currently processing the file that was uploaded to this slot, so you can only modify the data after emissions have been calculated. You can check this page later for updates.</bodyLarge>`,
      alertAwaitingData: `<titleSmall>Upload completed template</titleSmall>
         <bodyLarge>To submit your data, you need to complete the provided Excel file template. Once you’ve filled in the template, you should upload this single file below.</bodyLarge>
         <bodyLarge>Note that results are not instant as processing your submitted file may require additional data cleaning or review. This is necessary to ensure accurate and reliable results.</bodyLarge>`,
      alertDataIssue: `<titleSmall>Data issue being resolved</titleSmall>
       <bodyLarge>We’ve started processing the file that was uploaded to this slot but we’ve encountered an issue with the data.</bodyLarge>
       <bodyLarge>You cannot modify anything until the issue is resolved. However, check this page later for updates.</bodyLarge>`,
      alertEmissionsReady: `<titleSmall>Emissions already calculated</titleSmall>
      <bodyLarge>No further action is required as the file uploaded to this slot has been processed and emissions have been calculated from that data.</bodyLarge>
      <bodyLarge>However, you can still make updates to what’s been submitted by deleting the original file and replacing it with a new one. Note that the changes won’t be instant, as additional validation will be needed to ensure accurate and reliable results.</bodyLarge>`,
      alertNotApplicable: `<titleSmall>No action required</titleSmall>
      <bodyLarge>This submission has been marked as not applicable. If this is incorrect, please reach out to support@minimum.com.</bodyLarge>`,
      alertPartiallyComplete: `<titleSmall>Emissions already calculated</titleSmall>
      <bodyLarge>No further action is required as the file uploaded to this slot has been processed and emissions have been calculated from that data.</bodyLarge>
      <bodyLarge>However, you can still make updates to what’s been submitted by deleting the original file and replacing it with a new one. Note that the changes won’t be instant, as additional validation will be needed to ensure accurate and reliable results.</bodyLarge>`,
      surveyInstructions: `<titleSmall>Instructions</titleSmall>
    <bodyLarge>Fill in this form with relevant activity data for any of the entities listed above and within the stated time period.</bodyLarge>`,
      multiActivityAwaitingData: `<titleSmall>Upload completed template</titleSmall>
         <bodyLarge>To submit your data, you need to download the relevant Excel file template and fill it in. You should then upload the completed templates.</bodyLarge>
         <bodyLarge>To replace an existing file, <u>you must first delete it</u> before submitting a new replacement file. This prevents data duplication, since every submitted file will be processed accordingly.</bodyLarge>`,
      multiActivityFailedValidation: `<titleSmall>Resolve errors to continue</titleSmall>
         <bodyLarge>Errors were detected in files you uploaded previously - the relevant files are marked in red and include an error log that explains what’s wrong.</bodyLarge>
<bodyLarge>You can download the relevant file to make the corrections OR you can download a fresh template and fill it in again. Remember to delete the files with errors and upload your corrected files.</bodyLarge>`,
      downloadTemplatesTitle: "Available templates ({{count}})",
      allActivities: "All activities",
      downloadTemplate: "Download templates",
      downloadAll: "Download all",
      noTemplatesAvailable: "No templates available",
      uploaded: "Uploaded",
      updated: "Updated",
      fileErrorTooltip: "Data did not pass validation checks",
      varianceTooltip: "Data has unresolved variances",
    },

    [Group.SUBMISSION_SLOTS]: {
      bulkUploadTooltip:
        "Use bulk upload if you’re unsure which period your files belong to.",
      bulkUploadData: "Bulk upload data",
      noSubmissionSlots:
        "There are no Submission Slots for you to view at this time.",
      pendingDataToSubmit: "You have pending data to submit",
      files_one: "{{count}} file",
      files_other: "{{count}} files",
      surveys_one: "{{count}} survey",
      surveys_other: "{{count}} surveys",
      items: "Items",
      groups: "Groups",
      total: "Total",
      statusBreakdown: "Status Breakdown",
      statusCount_one: "{{statusCount}} status",
      statusCount_other: "{{statusCount}} statuses",
    },

    [Group.VARIANCE_CHECKS]: {
      notesRequired: "Notes (required)",
      notesOptional: "Notes (optional)",
      downloadFiles: "Download files",
      sendToSubmitter: "Mark to send to data submitter(s)",
      sendToSubmitterAlert:
        "You are about to send this entity back for review to the data submitter(s).",
      addedToAuditLog:
        "This will be added to the audit log for this datapoint.",
      ignoreWarning: "Ignore variance warning",
      ignoreWarningAlert:
        "You are about to ignore this variance warning. This action will be recorded in the audit log.",
      updateSourceFiles: "Update source files",
      updateSurvey: "View/edit response",
      resolveWithComment: "Resolve with comment",
      resolvedWithComment: "Resolved with comment",
      currentValue: "Current value",
      uploadAlert:
        "If you believe this file is incorrect, please upload a replacement one. This modification will be logged in the system along with the reason you provide, and will be recorded in the audit log for this submission.",
      skipUpdate: "Skip updating this value",
      viewNotes: "View {{count}} notes",
      noNotes: "No notes",
      varianceChecks: "Variance checks",
      varianceInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Review the detected variances below. Each entity shown has data that’s higher or lower than expected.</bodyLarge>
      <bodyLarge>If the figures are correct, add a comment explaining the reason for the variance before proceeding.</bodyLarge>
      <bodyLarge>If instead the variance is due to incorrect data, click Next to add or replace the underlying files.</bodyLarge>`,
      varianceInstructionSurvey: `<titleSmall>Instructions for surveys</titleSmall>
      <bodyLarge>We have detected variances for the following entities. Check your current responses by clicking on the row action to “View/edit response”. If there are errors in the form, you can edit and save changes within the preview modal.</bodyLarge>
      <bodyLarge>If there are no errors, close the form and add a comment to ignore that specific variance (e.g. if a variance is to be expected).</bodyLarge>
      <bodyLarge>Remember to click on the “Submit” button when you’re done.</bodyLarge>`,
      varianceInstructionMultiActivity: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Review the detected variances below. Each entity shown has data that’s higher or lower than expected.</bodyLarge>
      <bodyLarge>If the figures are correct, add a comment explaining the reason for the variance before proceeding.</bodyLarge>
      <bodyLarge>If instead the variance is due to incorrect data, click Next to add or replace the underlying files.</bodyLarge>`,
      varianceInstructionViewOnly: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Review the detected variances below. Each entity shown has data that’s higher or lower than expected.</bodyLarge>
      <bodyLarge>The Status column shows where each entity stands: “Data issue” still needs attention, “Comment added” means the variance has been explained, and “Resolved” means new source files were submitted.</bodyLarge>
      <bodyLarge>Select the number in the Comments column to read the full comment trail. This is a read-only view — return to the data submission to add comments or replace files.</bodyLarge>`,
      commentVarianceInstruction: `<bodyLarge>If the data we’ve received is correct – explain why this variance is expected. Your comment will be added to the audit log.</bodyLarge>
      <bodyLarge>If the data is incorrect – you should cancel this action and update the source files instead.</bodyLarge>`,
      commentPlaceHolder:
        "This field is mandatory. Explain why this variance is expected. ",
      addCommentTitle: `Add comment for {{entityName}} ({{activityName}})*`,
      addComment: "Add comment",
      checkingVariances: "Checking variances...",
      submittingVariances: "Submitting variances...",
      viewSourceFiles: "View source files",
      viewSourceFilesDescription:
        "<bodyLarge>You can review the files that provided this datapoint by viewing the files below. If the file is incorrect, then you can replace it on the next step.</bodyLarge>",
      viewSourceFilesDescriptionViewOnly:
        "<bodyLarge>You can review the files that provided this datapoint by viewing the files below.</bodyLarge>",
      emptyList: "There are no Tasks for you to view at this time.",
      editCurrentResponse: "Edit current response",
      editSurveyInstructions: `<bodyLarge>Check your response for any errors. If there are none, you should close this modal and choose the action to resolve this variance with a comment instead.</bodyLarge>
        <bodyLarge>If there are errors in your original response, correct them in the following form and save your edits.</bodyLarge`,
      resolveDataIssues: "Resolve data issues",
      updateFiles: "Update files",
      continue: "Continue",
      someVariancesTitle: "Some variances still need to be resolved",
      someVariancesDescription:
        "You've added a comment to some variances, but the rest are still outstanding. Choose how you'd like to proceed.",
      resolveDataIssuesIntro:
        "Resolve the outstanding issues by replacing the source files, or if the variance is expected, add a comment instead.",
      replaceSourceFilesTitle: "Replace the source files",
      replaceSourceFilesDescription:
        "Continue to add or replace files for the outstanding variances (comments will be saved).",
      addCommentsToRestTitle: "Add comments to the rest",
      addCommentsToRestDescription:
        "Go back to the review table and add a comment to each remaining variance.",
      addComments: "Add comments",
      allVariancesCommentTitle: "All variances have a comment",
      allVariancesCommentDescription:
        "You've added a comment to all variances in this submission. Choose how you'd like to proceed.",
      allVariancesExpectedTitle: "All variances are to be expected",
      allVariancesExpectedDescription:
        "The data is correct and the comments explain all the variances. Submit your data as it stands.",
      someVariancesIncorrectTitle: "Some variances are due to incorrect data",
      someVariancesIncorrectDescription:
        "The comments are still applicable but new files need to be uploaded to resolve variances",
      outstandingVariances: "Outstanding variances need to be resolved",
      outstandingVariancesDescription:
        "This submission has outstanding variances that need to be resolved. Comments were previously added against the data issues, but files need to be added or replaced to resolve the remaining issues for:",
      viewDataIssues: "View data issues",
      allActivities: "All activities",
    },

    [Group.INTEGRATION]: {
      collectData: "Collect data",
      dataFetchedSuccessfully: "Data fetched successfully",
      dataFetchFailed: "Failed to fetch data",
      info: "This activity is collected via an integration and does not require any manual data submission.",
    },

    [Group.FILES]: {
      info: `<bodyLarge>You should submit relevant data that tracks this activity for any of the entities listed above and within the stated time period.</bodyLarge>
      <bodyLarge>To replace an existing file, <u>you must first delete it</u> before submitting a new replacement file. This prevents data duplication, since every submitted file will be processed accordingly.</bodyLarge>`,
      loading: "Loading...",
      uploadData: "Upload data",
      uploadCompletedTemplates: `<titleSmall>Upload completed templates</titleSmall>
<bodyLarge>To submit your data, you need to download the relevant Excel file template and fill it in. You should then upload the completed templates to the relevant activity tab.</bodyLarge>
<bodyLarge>To replace an existing file, <u>you must first delete it</u> before submitting a new replacement file. This prevents data duplication, since every submitted file will be processed accordingly.</bodyLarge>`,
      failedValidationBannerFilesTemplates: `<titleSmall>Resolve errors to continue</titleSmall>
<bodyLarge>Errors were detected in files you uploaded previously - the relevant files are marked in red and include an error log that explains what’s wrong.</bodyLarge>
<bodyLarge>You can download the relevant file to make the corrections OR you can download a fresh template and fill it in again. Remember to delete the files with errors and upload your corrected files to the relevant activity tab.</bodyLarge>`,
      uploadFiles: "Upload files",
      downloadTemplates: "Download templates",
      uploadingFiles: "Uploading files...",
      validatingFiles: "Validating files...",
      removingFile: "Removing file...",
      fileErrorHeader: "Invalid file",
      fileError_one:
        "Address all errors and upload the corrected file to complete your submission.",
      fileError_other:
        "Address all errors and upload the corrected files to complete your submission.",
      fileErrorLink:
        "<bodyMedium><warnIcon />Unable to validate this file - <a>download error log</a> for details</bodyMedium>",
      fileWarningLink:
        "<bodyMedium><warnIcon />Possible variances detected with figures within this file. Please <a>review</a> and either add or replace files</bodyMedium>",
      errorBannerTitle: "Resolve errors to continue",
      errorBannerDescription:
        "Errors were detected in the file you've uploaded. To continue, resolve them and replace your previously uploaded file with the updated version.",
      confirmDeleteTitle: "Delete file",
      confirmDeleteDescription: "Are you sure you want to delete this file?",
      downloadAllFileName: "submission_templates.zip",
    },
  },

  [Namespace.ANALYTICS]: {
    [Group.DEFAULT]: {
      pageName: "Analytics",
      subTitle: "Deep dive into your organization’s carbon footprint.",
      noDataTitle: "Data not available",
      noDataText: "No data is available at the moment.",
    },
  },

  [Namespace.COLLECTION_STATUS]: {
    [Group.TABS]: {
      manualSubmission: "Manual submission",
      automatedCollection: "Automated collection",
      integrations: "Integrations",
      utilityConnections: "Utility connections",
      integrationsTooltip: "Minimum integrations with your data sources",
      utilityConnectionsTooltip:
        "Nectar connections with your utility providers",
    },
    [Group.DEFAULT]: {
      pageName: "Collection status",
      title: "Collection status",
      subTitle:
        "Track your organization’s collection progress – whether the data is being manually submitted or collected automatically via an integration.",
      noDataAvailable: "No data available",
      dataIssues_one: "{{count}} data issue",
      dataIssues_other: "{{count}} data issues",
      cadenceDescription_one:
        "From {{count}} group that is collected on a {{cadenceName}} cadence",
      cadenceDescription_other:
        "From {{count}} groups that are collected on a {{cadenceName}} cadence",
      seeSubmissions: "See submissions",
      weekly: "Weekly",
      monthly: "Monthly",
      quarterly: "Quarterly",
      yearly: "Yearly",
      cadenceSubmission_one: "{{cadenceName}} submission",
      cadenceSubmission_other: "{{cadenceName}} submissions",
      backButton: "Back to collection status",
      cadenceSubTitle:
        "An overview of progress for submissions that are currently open.",
      allSubmissionsTab: "All submissions",
      needsActionTab: "Needs action",
      awaitingDataTab: "Awaiting data",
      manualSubmissionDownloadFilename: "Manual submission active submissions",
      noSubmissions:
        "There are no active submissions for you to view at this time.",
      noFiles: "There are no files for you to view at this time.",
      submittedItemsTitle: "Submitted items",
      backToSubmissions: "Back to {{cadenceName}} submissions",
      header: "Track submitted items for your organization’s submissions.",
      integrationBadgeError: "Collection failed",
      integrationBadgePartiallyComplete: "Partially complete",
      integrationBadgeSuccess: "Emissions ready",
      integrationBadgeProcessing: "Processing",
      integrationIssuesHeader_zero: "No issues detected",
      integrationIssuesHeader_one: "{{count}} integration issue",
      integrationIssuesHeader_other: "{{count}} integration issues",
      integrationIssuesText:
        "The issue is being resolved. If you need more information, reach out to our support team.",
      backToCollectionStatus: "Back to collection status",
      integrationDetails: "Integration details",
      integrationDetailsDescription:
        "Review how your integration is configured as well as any data collection attempts made.",
      dataPeriod: "Data period",
      lastCollected: "Last collected",
      dataDownloaded: "Data downloaded",
      checkDownloads: "Check your downloads folder for the file.",
      emissionsReady:
        "Data was successfully collected and emissions have been calculated",
      awaitingData:
        "Data collection has not started - this is an upcoming slot",
      partiallyComplete:
        "Data was successfully collected but there is missing data",
      processingAndCalculating:
        "Data was successfully collected and is being processed",
      collectionFailed: "Unable to collect data",
      utilityConnections: "{{dataSourceName}} utility connections",
      statusSummary: "Status summary",
      statusConnected: "Connected",
      statusNotConnected: "Not connected",
      statusPending: "Pending",
      statusConnectedTooltip:
        "{{dataSourceName}} is successfully connected with your utility provider",
      statusNotConnectedTooltip:
        "{{dataSourceName}} is currently unable to connect with your utility provider",
      statusPendingTooltip:
        "This connection is configured but {{dataSourceName}} has not yet established the connection with your utility provider",
      connectionDetails: "Connection details",
      statusTooltipDate: "Since {{date}}",
      sourcesModalTitle_one: "{{count}} source for {{entity}} ({{provider}})",
      sourcesModalTitle_other:
        "{{count}} sources for {{entity}} ({{provider}})",
      apiNotReachableTitle: "{{dataSourceName}} API not reachable",
      apiNotReachableDescription:
        "<bodyMedium>Please try again later. If the problem persists, <a>contact our support team</a></bodyMedium>",
      draftsOnly: "Drafts only",
    },

    [Group.EMAIL]: {
      title: "Send email reminder",
      alert_one: `You are about to send email reminders to {{count}} data
              submitter or manager, according to the filters for
              activity, entity, status and and submission period you have set.`,
      alert_other: `You are about to send email reminders to {{count}} data
              submitters or managers, according to the filters for
              activity, entity, status and and submission period you have set.`,
      emailReminderTitle: "Sending a reminder to",
      noSubmittersOrManagers:
        "Email reminders cannot be sent because no submitters or managers are set for this selection.",
      emailRemindersButton: "Send email reminder",
    },
  },

  [Namespace.INTEGRATION_HEALTH]: {
    [Group.DEFAULT]: {
      pageName: "Integration health",
      subTitle: "Monitor the health of your integration connections.",
      noItemsMessage: "There are no data integrations to display at this time.",
      connectionName: "Integration Name",
      status: "Status",
    },
  },

  [Namespace.EMISSIONS]: {
    [Group.TABS]: {
      emissions: "Emissions",
      activityData: "Activity Data",
    },

    [Group.DEFAULT]: {
      loading: "Loading emissions...",
      emissionsLabel: "Emissions",
      emissionsSubtitle:
        "Displaying data of your organization’s carbon footprint.",
      estimatedEmissionsHint:
        "Percentage of emissions (in tCO₂e) that were estimated",
      estimatedLabel: "Estimated:",
      estimatedValueTooltip:
        "This is the percentage of emissions that have been estimated (based on tCO\u2082e)",
      estimatedUnknownTooltip:
        "The percentage of emissions that have been estimated is unknown for this time period",
      filterTooltip:
        "Applying date filters pro-ratas the emissions per the filters selected and affects start and end dates.  Pro-rata rows have dates in italics.",
      percentageOfTotalLabel: "% of total",
      totalEmissions: "Total Emissions",
      scope1Label: "Scope 1:",
      scope2Label: "Scope 2:",
      scope3Label: "Scope 3:",
      scope1: "Scope 1",
      scope2: "Scope 2",
      scope3: "Scope 3",
      estimated: "Estimated",
      showEmissions: "Show emissions",
      totalEmissionsHint:
        "Emissions are displayed using the consolidation approach configured for your account. Other columns are unconsolidated",
      noEmissions: "There are no emissions for you to view at this time.",
      viewEmissions: "View emissions",
      emissionDetailsDescription:
        "Displaying the complete data captured for this emission.",
      estimationMethod: "Estimation method",
      activityData: "Activity data",
      entityDetails: "Entity info",
      entityName: "Entity",
      city: "City",
      country: "Country",
      customEntityAttributes: "Entity custom attributes",
      activityInfo: "Activity info",
      scope: "Scope",
      activity: "Activity",
      scopeCategory: "Scope category",
      dateRange: "Date range",
      emissionDetails: "Emission info",
      emissionUnits: "Emission (tCO\u2082e)",
      actions: "Actions",
      entityHint: "Site or facility responsible for the emission occurring",
      scopeHint:
        "Greenhouse Gas Protocol scope assigned to the emission after consolidation",
      categoryHint: "Scope 3 category, if relevant",
      emissionHint: "Consolidated emission based on the accounting settings",
      estimatedTooltip: "This emission value was estimated",
    },

    [Group.FILTERS]: {
      filters: "Filters",
      entity: "Entity",
      reset: "Reset",
      dataSettings: "Data settings",
      export: "Export",
      dataSettingsTitle: "Organization structure as of {{date}}",
      scope2CalculationLabel: "Scope 2 calculation",
      consolidationApproachLabel: "Consolidation approach",
      locationBased: "Location based",
      marketBased: "Market based",
      displaySettings: "Display settings",
      none: "None",
      dateRange: "Date range",
      groupBy: "Group by",
      loading: "Loading filters...",
      noFilterableColumns: "No filterable columns available",
      clearAll: "Clear all ({{count}})",
      tags: "Tags",
      estimated: "Estimated",
    },

    [Group.ACTIVITY_DATA]: {
      pageName: "Activity Data",
      incompleteData:
        "The activity data is incomplete because some emissions that were reported to Minimum did not have activity data provided.",
      proRataTooltip:
        "Applying date filters pro-ratas the activity data value(s) per the filters selected and affects start and end dates. Pro-rata rows have dates in italics.",
      quantityTooltip:
        "The Activity Data quantity is displayed using the consolidation approach configured for your account. Other columns are unconsolidated",
      noDataForYear:
        "No data is available for {{year}}; this is a historical footprint that has been imported into the Minimum platform and the required data is unavailable",
      noActivityData: "There is no Activity Data for you to view at this time.",
    },

    [Group.EXPORT]: {
      exportActivityTitle: "Export Activity Data to Excel",
      exportActivityHeader:
        "Exporting activity data to Excel may take a couple of minutes.",
      exportBodyEmail:
        "Once the export is complete, we’ll email the download link to {{email}}.",
      startExport: "Start export",
      exportEmissionsTitle: "Export emissions to Excel",
      exportEmissionsHeader:
        "Exporting {{count}} entries will take a couple of minutes.",
      tooManyRowsTooltip:
        "Too many rows for Excel. Apply filters to reduce the dataset, then export.",
      alreadyExportedTooltip:
        "Already exported. Change your filters or date range to export a new dataset.",
      asyncExportStartedTitle: "Excel export started.",
      asyncExportStartedMessage:
        "You’ll receive an email with the download link shortly.",
      exportErrorTitle: "Export not successful.",
      exportErrorMessage: "Please try again later.",
      downloadSuccessTitle: "Download successful",
      downloadSuccessMessage: "The file should be in your downloads folder.",
    },

    [Group.SETTINGS]: {
      heading: "Carbon accounting settings",
      electricityDefaultApproach: "Electricity Calculation default approach",
      organizationStructure: "Organization structure as of",
      reportingEntity: "Reporting entity",
      consolidationApproach: "Consolidation approach",
      settingsHeader:
        "The following settings impact the emissions data displayed. Please note that these settings were configured for your account during onboarding. If you have any questions, please contact support.",
      consolidationSettings: "Consolidation settings",
      organizationStructureDate: "Use my organization structure as of date",
      reportingEntityUsed: "Reporting entity used to consolidate footprint",
    },

    [Group.AUDIT]: {
      submissionLog: "Submission log",
      calculationLog: "Calculation log",
      consolidationDetails: "Consolidation details",
      estimationDetails: "Estimation details",
      dataCollected: "Data collected",
    },

    [Group.CALCULATION]: {
      viewInputData: "View input data",
      calculationOverview: "Calculation overview",
      emissionFactor: "Emission factor",
      CO2unit: "kgCO\u2082e of CO\u2082 per unit",
      CH4unit: "kgCO\u2082e of CH\u2084 per unit",
      N2Ounit: "kgCO\u2082e of N\u2082O per unit",
      totalCO2: "Total kgCO₂e per unit",
      redactedTooltip:
        "Sorry, this Emission Factor can’t be displayed because it requires a licence. Please speak to your Customer Success contact for more information.",
      redacted: "Redacted",
      calculationMethodology: "Calculation methodology",
      importedTooltip: "This emission was not calculated by Minimum",
      imported: "Imported",
      thirdPartyTooltip:
        "This emission was provided by a third party and not calculated by Minimum",
      unknown: "Unknown",
      emissionFactorType: "Emission factor type",
      primaryTooltip:
        "Publicly available emission factors published by a widely recognised source. May be subject to a licence fee.",
      primary: "Primary",
      benchmarkedTooltip:
        "Emission factor derived by Minimum, usually based on a primary emission factor combined with statistical data.",
      benchmarked: "Benchmarked",
      emissionFactorSource: "Emission factor source",
      globalWarmingPotentialSet: "Global Warming Potential set",
    },

    [Group.OVERVIEW]: {
      emissionOverview: "Emission Overview",
      estimated: "Estimated",
      reportingEntity: "Reporting Entity",
      emissionOriginatedFrom: "Emission originated from",
    },

    [Group.CONSOLIDATION]: {
      consolidationDetails: "Consolidation Details",
      preConsolidatedFootprint: "Emission pre-consolidated footprint",
      postConsolidatedFootprint: "Emission post-consolidated footprint",
      emissionsOwnedBy: "Emissions owned by {{entity}}",
      scopeTranslation: "Scope translation",
      scopePhrase: "Scope {{scope}} {{name}}",
      percentageInherited: "Percentage inherited",
      inheritedDescription:
        "The original emission was inherited by <heading>{{entity}}</heading> after being consolidated through the following Entities in your organization:",
      timePeriodForConsolidation: "Time period for consolidation",
      consolidationApproach: "Consolidation approach",
    },

    [Group.SUBMISSION]: {
      emptyMessage:
        "There is no data available to view, please contact support if you require more information",
      minimumPlatform: "Minimum Platform",
    },
  },

  [Namespace.DOCUMENTS]: {
    [Group.DEFAULT]: {
      subTitle:
        "Access and manage documents and certificates for your organization",
      uploadDocument: "Add document",
      documentUpload: "Upload new document",
      referenceDocumentUpload: "Upload new reference data",
      noDocuments: "There are no documents for you to view at this time.",
      archiveDocument: "Archive document",
      confirmDeleteDocument:
        "Once archived, your document will no longer be visible in this list.",
      confirmDeleteReferenceDocument:
        "Proceed with caution. Archiving this reference data may cause associated transformers to fail.",
      confirmArchive: "Confirm archive",
      updateDetails: "Update details",
      updateSaved: "Update saved",
      goToDocuments: "Go to Documents",
      confirmSave: "Please confirm you wish to save this data",
      saveData: "Save data",
      updateRelatedDetails: "Update details that relate to your document.",
      selectMetadata: "Please enter or select metadata value",
      downloadLinkExpiredHeader: "Download link expired",
      downloadLinkExpiredText:
        "Return to the Emissions page and restart the export. Note that the download link expires after 48 hours.",
      downloadSuccessHeader: "Download successful",
      downloadSuccessText: "The file should be in your downloads folder.",
      restrictedAccessHeader: "Restricted access",
      restrictedAccessText: "You do not have access to view this page.",
      returnToPage:
        "Return to the {{page}} page and restart the export. Note that the download link expires after 48 hours.",
      fileDetails: "File details",
      exportedFrom: "Exported from",
      numberEntries: "No. of entries",
      previewFile: "Preview file",
      downloadFile: "Download file",
      documentName: "Document name",
      editDocument: "Edit document",
      cannotDeleteDocument: "Can only be archived by original uploader",
      internalUserOnlyEdit: "Can only be edited by Minimum team",
      internalUserOnly: "Can only be archived by Minimum team",
      documentCategory: "Document category",
      relatedEntities: "Related entities",
      typeToSearch: "Type to search",
      typeToSearchOrCreate: "Type to search or add new ones",
      fileDescription: "File description",
      discardChanges: "Discard changes",
      referenceDataType: "Reference data type",
      selectDate: "Select a date",
      loading: "Loading...",
      selectOne: "Select one",
      referenceFileUploadMessage:
        "You can upload 1 file. It must be in .xlsx format.",
      referenceDescriptionPlaceHolder:
        "Give extra context about this document, such as how it should be used.",
      invalidFile: "Invalid file",
      invalidFileMessage:
        "Replace the current file with a valid one to continue.",
      uploadSuccessful: "Upload successful",
      successMessage: "Your document has been added.",
      uploadFailedTitle: "Upload unsuccessful",
      uploadFailedMessage: "Your document has not been added.",
      uploadFailed: "Upload failed",
      pleaseTryAgain: "Please try again.",
    },

    [Group.UPLOAD]: {
      fileTooLarge: "File is too large, max size is {{maxSize}}MB",
      fileNotSupported:
        "This file type ({{ext}}) is not supported. Please choose a different file.",
      clickToUpload: "Click to upload",
      dragAndDrop: "or drag and drop",
      fileOnly: "file only",
      files: "files",
      addNewDocument: "Add new document",
      uploadModalTitle: "Choose the type of document you want to upload.",
      continueToUpload: "Continue to upload",
      uploadFile: "Upload file",
      uploadContent:
        "You can upload 1 file. It must be in one of these formats: .csv, .doc, .docx, .eml, .gif, .jpg, .jpeg, .msg, .pdf, .png, .txt, .xlsx",
      instructionsTitle: "Instructions",
      instructionUploadFile: "Start by uploading your file.",
      instructionSubmit:
        "Once you've filled in all of the mandatory document details, hit 'Submit' to finish adding your document.",
      helperTextCategory: "This helps identify what type of document it is.",
      selectReferenceDocument:
        "Select the relevant reference data type used by your transformer(s).",
      uploadFileForReference: "Upload the file to be referenced.",
      fillInDocumentDetails:
        "Fill in all mandatory details, then hit ‘Submit’ to finish adding your reference data.",
      referenceHelperText:
        "This name is referenced by at least one transformer for this organization.",
      unSubmittedChanges: "Unsubmitted changes",
      unSubmittedChangesMessage:
        "Do you want to discard your changes or continue with your submission?",
      continueSubmission: "Continue submission",
      lockTooltipMessage:
        "This data type is linked to the current file. Delete the file to change it.",
    },

    [Group.UPDATE]: {
      updateDocumentDetails: "Update document details",
      updateInstructions: `<bodyLarge>You can only update the document details. Remember to save any changes when you’re done.</bodyLarge>
      <bodyLarge>If you need to replace this file, you should <u>upload a new document</u> and delete this one.</bodyLarge>`,
      helperTextCategory: "This helps identify what type of document it is. ",
      unSavedUpdates: "Unsaved updates",
      unsavedUpdatesMessage:
        "Do you want to discard your changes or continue updating your document?",
      continueUpdating: "Continue updating",
      saveChanges: "Save changes",
      updateSuccessful: "Updates saved",
      updateSuccessMessage: "Your document has been updated.",
      updatesFailed: "Updates not saved",
      updatesFailedMessage:
        "Your document was not updated. Try again later or contact our team for help.",
      updateReferenceData: "Update reference data",
      updateReferenceInstructions: `<bodyLarge>You can replace the file or update the validity dates. The reference data type <u>cannot</u> be changed. </bodyLarge>
      <bodyLarge>Remember to save any changes when you’re done.</bodyLarge>`,
      lockTooltipMessage:
        "For versioning consistency, this class name cannot be altered",
      archiveFile: "This will archive the file",
    },
  },

  [Namespace.METHODOLOGIES]: {
    [Group.DEFAULT]: {
      description: "Displaying the methodologies available.",
      learnMore: "Learn more",
      methodologyDetails: "Methodology details",
      scopeCategoryOverride: "Scope/Category Override",
    },
  },

  [Namespace.TRANSACTIONS]: {
    [Group.DEFAULT]: {
      subTitle: "View the list of audit-ready records of your emission.",
      totalLabel_one: "Total emissions for {{count}} result",
      totalLabel_other: "Total emissions for {{count}} results",
      scope1: "S1",
      scope2: "S2",
      scope3: "S3",
      noTransactions: "There are no transactions for you to view at this time.",
      emissionsInTransaction_one:
        "Displaying {{count}} emission recorded in this Transaction",
      emissionsInTransaction_other:
        "Displaying {{count}} emissions recorded in this Transaction",
      transactionDetails: "Transaction Details",
      entityCount_one: "{{count}} entity in this transaction",
      entityCount_other: "{{count}} entities in this transaction",
    },
  },

  [Namespace.HUB]: {
    [Group.DEFAULT]: {
      downloadInputData: "Download input data",
      emissionCalculationTests: "Emission calculation tests",
      runEmissionCalculateionTest: "Run emissions calculations test",
      viewErrorLogCount_one: "View error log ({{count}} error detected)",
      viewErrorLogCount_other: "View error log ({{count}} errors detected)",
    },

    [Group.BUSY_MESSAGES]: {
      fileUploadInProgress: "File upload in progress...",
      updatingEntity_one: "Updating entity...",
      updatingEntity_other: "Updating entities...",
      loadingMissingEntities: "Checking entities...",
      loadingTask: "Loading task...",
      loadingVarianceChecks: "Loading variance check...",
      checkingVariances: "Checking variances...",
      ignoringVariance: "Ignoring variance detected...",
      downloadingFile: "Downloading file...",
      savingFile: "Saving file...",
      uploadSchema: "Uploading schema...",
    },

    [Group.TASKS]: {
      pageName: "Task queue",
      pageSubtitle: "All data tasks.",
      switchToNewDashboardView: "Switch to new dashboard view",
      dataProcessingDashboard: "Data processing dashboard",
      dataProcessingDashboardDescription:
        "Monitor how well our system processes the data we’ve collected",
      switchToClassicDashboardView: "Revert to classic task queue",
      selectOrganisation: "Select organization",
      recalculate: "Recalculate",
      resetConfirmationText:
        "Resetting a task will revert you back to the data cleaning step.  Are you sure you wish to continue?",
      returnToTaskList: "Return to task list",
      resetData: "Reset data",
      resetComplete: "Reset completed",
      resetDescription: "Your data task has been reset",
      showComplete: "Show complete",
      showActive: "Show active",
      cannotRecalculateTask:
        "You cannot recalculate this task because it is claimed by another user",
      cannotResetClassificationTask:
        "It is not possible to reset classification tasks",
      cannotResetClaimedTask:
        "You cannot reset this task because it is claimed by another user",
      returnToMissingData: "Update missing entities",
      cannotReturnToMissingData:
        "You cannot update missing entities because this task is claimed by another user",
      confirmReturnToMissingDataTitle: "Update missing entities",
      confirmReturnToMissingDataText:
        "You'll be taken back to the 'Missing data checks' step where you can mark missing entities as not applicable.",
      returnToMissingDataSuccessHeader: "Task updated",
      returnToMissingDataSuccessMessage:
        "The task has been returned to the missing data step.",
      viewTask: "View task",
      returnToMissingDataSuccessTitle:
        "Successfully returned to missing data step",
      emptyList: "There are no Tasks for you to view at this time.",
      tabActionRequired: "Action required",
      tabCustomerAction: "Customer action",
      tabSystemTask: "System task",
      tabNoActionRequired: "No action required",
      processingStageLabel: "Processing stage",
      reportingPeriodLabel: "Reporting period",
      slotPeriodLabel: "Slot period",
      lastUpdatedLabel: "Last updated",
      escalatedTooltipMessage:
        "ESCALATED: waiting on data submitter to resolve the variance issue",
      blockedTooltipMessage:
        "BLOCKED: view slot details and resolve issues to continue",
      lockedTooltipMessage:
        "LOCKED: please wait – do not interfere with the system",
      fullEmissionsTooltipMessage: "All emissions calculated",
      partialEmissionsTooltipMessage: "Some emissions calculated",
      noEmissionsTooltipMessage: "No emissions",
      escalatedViewTooltipMessage:
        "ESCALATED: please wait for the data submitter to complete their actions",
      lockedViewTooltipMessage:
        "LOCKED: please wait – do not interfere with the system",
      draftActionDisabledTooltip:
        "UNSUBMITTED: please wait for data submitter to submit data",
      draftTooltipMessage: "Slot contains unsubmitted data",
      validationFailedTooltipMessage:
        "Data submitter notified that validation failed",
      validationFailedViewTooltipMessage:
        "BLOCKED: please wait for data submitter to resolve data issues",
      validatingTooltipMessage: "Data submitted and being validated",
      validatingViewTooltipMessage:
        "BLOCKED: please wait for data validation to be completed",
    },

    [Group.TASK_DETAILS]: {
      uploadedSchema: "Uploaded schema",
      addMethodology: "Add methodology",
      confirmRemoveMethodologyTitle: "Confirm delete",
      confirmRemoveMethodologyText: `Are you sure you want to delete this methodology?
      Uploaded schemas will be archived.`,
      editMethodologyList: "Edit methodology list",
      noSourceDataActivity: "No source data for this activity",
      removeMethodology: "Remove methodology",
      selectMethodology: "Select methodology",
      sourceDataExists: "Source data exists",
      downloadTemplate: "Download template",
      methodologyTemplateIntro:
        "The following is a description of each column for which you're required to provide data. You can download the template by clicking the button above.",
      methodologyTemplateExample:
        "Below is an example row of valid data you can submit.",
      required: "*",
      options: "Options",
      refreshData: "Refresh data",
      confirmRefreshDataTitle: "Confirm data refresh",
      confirmRefreshDataText:
        "This will replace the previously collected data before attempting to transform and process the data again.",
      cannotRefreshData:
        "You cannot refresh this task because it is claimed by another user.",
      confirmRefreshData: "Confirm refresh",
      refreshDataAttempted: "Data refresh attempted",
      refreshDataToasterMessage:
        "Check task to see if emissions were successfully generated.",
      reprocessData: "Reprocess data",
      reprocess: "Reprocess",
      confirmReprocessDataTitle: "Confirm data reprocessing",
      confirmReprocessDataText:
        "This will attempt to transform and process the automatically collected data again.",
      confirmReprocessDataTransformer:
        "This will attempt to transform and process the data again.",
      cannotReprocessData:
        "You cannot reprocess this task because it is claimed by another user.",
      confirmReprocessData: "Confirm reprocess",
      reprocessDataAttempted: "Data reprocessing attempted",
      reprocessDataToasterMessage:
        "Check task to see if emissions were successfully generated.",
      automationCollectionError: "Automation collection error",
      automationCollectionErrorMessage: `<bodyMedium>Data was collected automatically but either of these scenarios might have occurred:</bodyMedium>
      <bodyMedium><li>There are unmapped entities - go to Back Office and update your entity aliases, then come back here to reprocess the task.</li>
      <li>The integration transformer has failed - it needs to be updated.</li></bodyMedium>
      <bodyMedium>Check the error log for more information.</bodyMedium>`,
      viewErrorLog: "View error log",
      encodedDataInstructions: `<titleSmall>Instructions for encoded methodologies</titleSmall>
      <bodyLarge>Before running the cleaned data through the calculation engine, we need to resolve any errors that might interfere with the calculation. Click the ‘Run test calculation’ button for a preview of the emissions output from your cleaned data.</bodyLarge>`,
      encodedIntegrationDataInstructions: `<titleSmall>Instructions for automatic collection</titleSmall>
      <bodyLarge>Before running the automatically collected data through the calculation engine, we need to resolve any errors that might interfere with the calculation. Click the ‘Run test calculation’ button for a preview of the emissions output from your cleaned data.</bodyLarge>`,
      runTestCalculation: "Run test calculation",
      missingData: "Missing data",
      missingEntities: "Missing entities",
      missingDataInstructions: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>There are missing data points in the schema that need to be resolved. Download the schema and fill in the missing values, then upload the updated schema.</bodyLarge>
      <bodyLarge>If you need to add new values for missing entities, DO NOT add new rows to the schema – you should reset this task.</bodyLarge>`,
      downloadYourSchema: "Download your schema",
      uploadUpdatedSchema: "Upload updated schema",
      uploadCorrectedSchema: "Upload corrected schema",
      uploadModifiedTemplate: "Upload modified template",
      noMissingDataText: "All data points are complete.",
      noVariancesDetected: "No variances detected.",
      noFurtherActionRequired: "No further action required",
      usingMethodology: "using {{name}} methodology",
      resolveErrorTitle: "Resolve errors to continue",
      resolveErrorContent:
        "Errors were detected in your cleaned data. Before you can move to the next step, you must resolve all of these errors and upload your updated schema. ",
      downloadSchemaContent: "Check your downloads folder for the schema.",
      downloadSchemaTitle: "Schema downloaded",
      downloadedSchemaText: "Check your downloads folder for the schema.",
      encodedNoErrorInstructions: `<titleSmall>Instructions before you submit</titleSmall>
      <bodyLarge><successIcon /> No errors were detected in your cleaned data. You can preview the emissions output by clicking ‘Download output preview.’</bodyLarge>
      <bodyLarge>
      <ul>
      <li>If you discover errors and need to make changes, click on ‘Update cleaned input data’.</li>
      <li>Otherwise, you can submit this task.</li>
      </ul>
      </bodyLarge>`,
      integrationWarning: `<bodyLarge><warnIcon />  Note that any manual changes you make now will eventually be overridden if the data happens to be reloaded in future.</bodyLarge>`,
      nonEncodedNoErrorInstructions: `<titleSmall>Instructions before you submit</titleSmall>
      <bodyLarge><successIcon/> No errors were detected in your cleaned data.</bodyLarge>
      <bodyLarge>
      <ul>
      <li>If you discover errors and need to make changes, click on ‘Update cleaned input data’.</li>
      <li>Otherwise, you can submit this task.</li></ul></bodyLarge>`,
      downloadOutputPreview: "Download output preview",
      updateCleanedInputData: "Update cleaned input data",
      inputDataDownloaded: "Input data downloaded",
      outputPreviewDownloaded: "Output preview downloaded",
      customInstruction: `<titleSmall>Instructions for non-encoded methodologies</titleSmall>
      <bodyLarge>As this methodology is not encoded, you’ll need to manually configure the schema to pass it through the calculation engine. Start by downloading the input template and making the necessary modifications (see <u>Product User Guide</u> for help).</bodyLarge>
      <bodyLarge>You should then upload the modified template.</bodyLarge>`,
      downloadInputTemplate: "Download input template",
      inputTemplateDownloaded: "Input template downloaded",
      inputTemplateDownloadContent:
        "Check your downloads folder for the template file.",
      reportedInstructions: `<titleSmall>Instructions for reported emissions</titleSmall>
      <bodyLarge>Before running the cleaned data through to final emissions, we need to resolve any errors that might interfere with processing. Click the ‘Run validation’ button for a preview of the emissions output from your cleaned data.</bodyLarge>`,
      reportedIntegrationInstructions: `<titleSmall>Instructions for automatic collection</titleSmall>
      <bodyLarge>Before running the automatically collected data through to final emissions, we need to resolve any errors that might interfere with processing. Click the ‘Run validation’ button for a preview of the emissions output from your cleaned data. </bodyLarge>`,
      runValidation: "Run validation",
      missingDataErrorTitle: "Error uploading updated schema",
      missingEntityErrorTitle: "Error updating status",
      downloadSchema: "Download schema",
      noMissingEntitiesText: "All entities are complete.",
      missingEntitiesInstructions: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>There are expected entities missing from the schema that need to be resolved. If the entities are not applicable or are still awaiting data, you can mark them here.</bodyLarge>
      <bodyLarge>If you need to add new values for missing entities, you should reset this task.</bodyLarge>`,
      missingProcessed:
        "Your previous missing data resolutions have been applied.",
      missingInvalidated:
        "If you made changes to this activity in a previous step, you may need to resolve any missing data resolutions.",
      notApplicable: "Not applicable",
      stillAwaitingData: "Still awaiting data",
      unresolved: "Unresolved",
      fileUploadedSuccessfully: "File uploaded successfully",
      surveyUploadedSuccessfully: "Survey uploaded successfully",
      errorsStillDetectedTitle: "Errors still detected",
      errorsStillDetectedText:
        "Check that you've addressed all missing data issues.",
      varianceInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>We’ve detected variances for the following entities. Start by checking if a variance was caused by a cleaning error. You should then download the schema, correct the incorrect values and then upload the updated schema.</bodyLarge>
      <bodyLarge>After you’ve updated the schema (if there were cleaning errors), you can then either ignore OR escalate the remaining variances back to the data submitter to resolve.</bodyLarge>`,
      escalateVarianceInstruction: `<bodyLarge>You might want to ask if the data we've received is correct and if so, whether this variance is expected.</bodyLarge>
      <bodyLarge>Your comment will not be shown in the audit log.</bodyLarge>`,
      noSourceData: "No source data",
      nothingSubmitted: "Nothing has been submitted for this activity.",
      noActionRequired: "No action required",
      downloadExistingData: "Download existing data",
      activityNotProvided: "Activity data has not been provided.",
      classificationInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Map each file to the appropriate submission slot (e.g. January).</bodyLarge>`,
      cleaningInitialInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Download the template and input data against the appropriate column headers. You should then upload the populated schema to submit your cleaned data.</bodyLarge>`,
      dontHaveToModify:
        "You don't have to modify anything unless you want to make changes.",
      cleaningProcessedInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>If you need to make changes to data that’s already been submitted, download the existing data and make your updates in that Excel file - using a previously saved schema will not work. You should then upload the updated file to submit your updates.</bodyLarge>`,
      entityMappingInstructions: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Download the schema and manually map the missing entities to the highlighted rows, then upload your updated schema.</bodyLarge>`,
      parameterMappingInstruction: `<titleSmall>Instructions</titleSmall>
      <bodyLarge>Check that the metadata in your schema ('Field name') is correctly mapped to the parameters of the calculation engine ('Calculation parameter').</bodyLarge>`,
      paramterMappingProcessed:
        "Your previous parameter mappings have been applied. You don’t have to modify anything unless you want to make changes.",
      updatesRequired: "Updates required",
      updatesMayRequired: "Updates may be required",
      parameterMappingInvalidated:
        "You made changes to this activity in the previous step, so you need to review your parameter mappings, and ensure metadata is selected correctly.",
      encodedProcessed:
        "If you need to recalculate the emissions, follow the instructions.",
      encodedInvalidated:
        "You made changes to this activity in a previous step, so you now need to re-run the calculation engine for this activity. ",
      offlineProcessed:
        "If you need to update any emissions that were calculated offline, follow the instructions.",
      offlineAndReportedInvalidated:
        "You made changes to this activity in a previous step, so you now need to update the schema by following the instructions. ",
      reportedProcessed:
        "If you need to revalidate the emissions, follow the instructions.",
      varianceInvalidated:
        "You made changes to this activity in a previous step, so you need to resolve your variance warnings.",
      varianceProcessed:
        "Your previous variance check resolutions have been applied. You don’t have to modify anything unless you want to make changes.",
      escalateDataSubmitter: "Escalate to data submitter",
      escalatePlaceHolder:
        "This field is mandatory. Provide context and any clarification requests.",
      escalate: "Escalate",
      addCommentTitle: `Add comment for {{entityName}} ({{activityName}})*`,
      noActionRequiredDescription: `<bodyMedium>This activity has been marked as not applicable. You can change this now or after completing all the steps for this data task.</bodyMedium>
      <bodyMedium>Updates can be made in the Back Office under ’View submission slots of {{organization}}’.</bodyMedium>
      `,
      previewTemplate: "Preview template",
      cleaningResolveErrorsTitle: "Resolve errors to continue",
      cleaningResolveErrorsDescription: `<bodyMedium>Errors were detected in the cleaned schema(s) that you've uploaded. Before you can move to the next task, you must resolve all of these errors.</bodyMedium>
      <bodyMedium>View the error log to identify which activity-methodology combinations are affected. Then download the relevant schema(s) and upload your updated schema(s).</bodyMedium>`,
      replaceFile: "Replace file",
      uploadFile: "Upload file",
      failedUploadRetry: "Failed to upload file, please try again",
      schemaDownloadedHeader: "Schema downloaded",
      schemaDownloadedMessage: "Check your downloads folder for the schema.",
      templateName: "{{name}}_template",
      claimTask: "Claim task",
      autoProcess: "Auto-process",
      manuallyProcess: "Manually process",
      viewExistingData: "View existing data",
      completedDescription:
        "Final emissions have been generated. You can download the submitted schema to review it. If you need to make any changes, reset the task.",
      downloadSubmittedSchema: "Download submitted schema",
      surveyCompletedDescription: `<bodyMedium>Final emissions have been generated. You can download the submitted schema to review it or <u>review the submitted survey answers</u> if necessary.</bodyMedium>
        <bodyMedium>If you need to make any changes, reset the task.</bodyMedium>`,
      instructionsForSurvey: `<titleSmall>Instructions for surveys</titleSmall>
      <bodyLarge>Download the template and input the survey data against the appropriate column headers. You should <u>refer to the submitted survey answers.</u></bodyLarge>
      <bodyLarge>You should then upload the populated schema to submit your cleaned data.</bodyLarge>`,
      uploadOneFile: "Upload one file only",
      uploadSchema: "Upload schema",
      errorTitle400Status: "Oops...",
      errorTitleOtherStatus: "Error unclear",
      errorOtherStatusDescription:
        "We’re not sure what went wrong. If this keeps happening, let us know by creating a dev support ticket.",
      filesUpdatesToResolve: `<titleSmall>Files updated to resolve variances</titleSmall>
      <bodyMedium>The data submitter may have replaced or added new files for this submission slot. Check the activity tabs for new files that need to be cleaned - they should be the ones marked as “NOT USED”.</bodyMedium>
      <bodyMedium>If a file has been replaced, remember to remove the file IDs for the old file from the schema.</bodyMedium>`,
      surveyUpdatesToResolve: `<titleSmall>Survey response updated to resolve variances</titleSmall>
      <bodyMedium>The data submitter has updated the survey response for this submission slot. Check the activity tabs for new responses that need to be cleaned.</bodyMedium>`,
      transformerMessage: `<bodyLarge><warnIcon /> Note that any manual changes you make now will eventually be overridden if the data happens to be reloaded in future.</bodyLarge>`,
      emptyFileList: "There are no files for you to view at this time.",
      failedActivitySave: "Failed to save Activity Methodologies",
    },
  },
};
